import {
  Button,
  Card,
  Modal,
  ModalCloseButton,
  Section,
  SectionTitle,
} from '@presentation/components';
import { Illustration } from '@presentation/components/Illustration';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import type { InfosModalProps } from './types';

export const InfosModal: FC<InfosModalProps> = (props) => {
  const { firstName, onConfirm, modal } = props;
  const { translate } = useTranslation();
  const { translate: translateRessource } = useTranslation({
    keyPrefix: 'common.modals.infosApplication',
  });

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Section centerChildren>
          <SectionTitle>{translateRessource('title').replace('$name', firstName)}</SectionTitle>
          <Illustration type="puppy-love" />
          <RootStyled.ModalText>{translateRessource('text')}</RootStyled.ModalText>
          <RootStyled.ModalSubText>{translateRessource('subtext')}</RootStyled.ModalSubText>
        </Section>
        <div>
          <RootStyled.ButtonWrapper>
            <Button onClick={onConfirm} color="blue" size="large">
              {translate('common.buttons.continue')}
            </Button>
          </RootStyled.ButtonWrapper>
        </div>
      </Card>
    </Modal>
  );
};
